<template>
  <div class="report" v-cloak>
    <div class="investor-nav tnavList">
      <router-link :to="{name:'Overview'}" class="investor-nav-item">概述</router-link>
      <router-link :to="{name:'BoardMember'}" class="investor-nav-item">董事会成员</router-link>
    </div>
    <router-view/>
  </div>
</template>
<script>

/**
 * 公司治理
 */
export default {
  name: 'CorporateGovernance',
  data () {
    return {
      isRouterAlive:true
    }
  },
  mounted() {
    this.$router.push({
      name:'Overview'
    });
  }
}

</script>
<style scoped>

  .report {
    font-size: 1rem;
  }
  .investor-nav {
    height: 2rem;
    padding: .6rem 5vw .2rem 5vw;
    background: #fff;
    box-shadow: 0 0 1rem rgba(0,0,0,0.1);
  }

  .investor-nav-item {
    padding: .2rem 0 .3rem 0;
    margin: 0 1rem;
    color: #333;
    border-bottom: 2px solid #fff;
  }
  .investor-nav-item.router-link-active {
    color: #333;
    border-bottom: 2px solid #ff7800;
  }
</style>



// WEBPACK FOOTER //
// src/components/investor/CorporateGovernance.vue